import React from "react";
import TLink from "../components/TLink";
import { checkTextTranslation, pathMaker } from "../utils/useful";
import { siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import TabBarItem from "../components/boxes/TabBarItem";
import { withRouter } from "react-router-dom";

class TabBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tabs: [

                // { name: '{{lang}}Home', href: '/', key: 'home', icon: '/images/dash.svg', page: '/' },

                { name: '{{lang}}admin', href: '/admin', key: 'admin', icon: '/images/icons2/082-quality.svg', page: 'admin',  },

                { name: '{{lang}}trading',href: '/trading', key: 'trading', icon: '/images/icons2/028-monitor.svg', page: 'trading' },

                { name: '{{lang}}statistics', href: '/statistics', key: 'statistics', icon: '/images/icons2/pie-chart.svg', page: 'statistics',  },



                { name: '{{lang}}services',href: '/services', key: 'services', icon: '/images/icons2/033-box.svg', page: 'services' },
                { name: '{{lang}}insurance', href: '/insurance', key: 'insurance', icon: '/images/icons2/002-wallet.svg', page: 'insurance' },


                // { name: '{{lang}}services', key: 'services', icon: 'https://www.flaticon.com/svg/static/icons/svg/2055/2055895.svg', page: 'Tower' },
                // { name: '{{lang}}settings', key: 'settings', icon: 'https://www.flaticon.com/svg/static/icons/svg/565/565591.svg', page: 'Tower' },
                // { name: '{{lang}}Edit Thing', href: '/thing/id', key: 'thing', icon: '/images/settings-3.svg', page: 'Tower' },
                // { name: '{{lang}}rigram', href: '/rigram', key: 'regram', icon: '/images/zoom-fit.svg', page: 'Tower' },
                // { name: '{{lang}}addnew', key: 'newService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}editService', key: 'editService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}removeService', key: 'removeService', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'services' },
                // { name: '{{lang}}addVeryNew', key: 'addVeryNew', icon: 'https://www.flaticon.com/svg/static/icons/svg/3465/3465222.svg', page: 'Tower', parent: 'newService' },

            ],
            tabTree: [],
            selected: 0
        }

    }

    componentDidMount() {
        let tabs = this.state.tabs
        let tabTree = []

        tabs.forEach(tab => {
            if (!tab.children) {
                tab.children = []
            }
            if (!tab.parent) {
                tabTree.push(tab)
            } else {
                this.findParent(tabs, tab)
            }
        });

        // console.log(tabTree)
        this.setState({ tabTree })
    }

    findParent(tabs, tab) {
        tabs.forEach(oneTab => {
            if (oneTab.key == tab.parent) {
                if (!oneTab.children) {
                    oneTab.children = []
                }
                oneTab.children.push(tab)
            }
        });
    }

    changePage = (prop) => {
        this.setState({ selected: prop.key })
        if (prop.href) {
            this.props.history.push(pathMaker(prop.href))
        }
    }
    render() {
        // console.log("isMobile")
        // console.log(this.props.settings.isMobile)
        return (
            // <div style={{ overflow: 'auto', height: '100vh', position: 'sticky', top: 0, width: "100%" }}>
            <div className={" tabBar " + (this.props.settings.tabBarOpen ? 'tabBarOpen ' : '') + (this.props.settings.isMobile ? 'mobile' : 'desktop')} style={{}}>
                {/* <div className="w-100" style={{ overflow: 'visible' }}> */}
                <div className="w-100 tabBar-container" style={{ position: 'relative', overflow: 'auto', height: '100%' }}>
                    {/* <div style={{ position: 'relative', }}> */}
                    {/* <div > */}
                    <div className="flexcc tabBarLogo" style={{ width: '100%' }}>
                        <TLink className="" to={'/'} style={{ width: '100%', height: '100%', textAlign: 'center', justifyContent: 'center' }}>
                            <img style={{ width: '80%', maxHeight: '95%', maxWidth: 120, objectFit: 'contain' }} src={siteTheme.logo} />
                        </TLink>
                    </div>

                    <div className={'tabsList '} style={{}}>
                        {/* <div> */}
                        {this.state.tabTree.map((prop, index) => {
                            return (
                                <TabBarItem tabBarOpen={this.props.settings.tabBarOpen} isMobile={this.props.settings.isMobile} data={prop} key={index} index={index} selected={this.state.selected === index} changePage={this.changePage} padding={0} />
                            )
                        })}
                        {/* </div> */}

                    </div>


                    {/* <div style={{ height: 80 }}>
                    </div> */}



                </div>

                <button className="tabBarOpenButton flexcc" onClick={() => this.props.actions.toggleSetting('tabBarOpen')} >
                    <img src={"/images/carrow.svg"} width="23px" alt="" />
                </button>
            </div>
            // </div>
            // </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TabBar));

